import { render, staticRenderFns } from "./CuentasxcobrarDetails.vue?vue&type=template&id=94583ab6&"
import script from "./CuentasxcobrarDetails.vue?vue&type=script&lang=js&"
export * from "./CuentasxcobrarDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports